<template>
  <l-modal :showing="showing" text="Add calculated timeserie" icon="plus-square" color="bg-pastel-green-500" @close="close">
    <div class="w-full flex flex-col text-xs">
      <div class="w-full mb-4">        
        <b>Station</b><br>
        <l-select v-model="staSelection" class="text-xs" :data="stations" placeholder="Please select a station" :multiple="false" >
            <l-option v-for="i in stations" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
          </l-select>       
      </div>
      <div class="flex mb-4">
        <div class="w-full mr-4">        
          <b>Primary</b><br>
          <l-select v-model="addObj.primary" class="text-xs" :data="timeseries" placeholder="Please select" :multiple="false" >
            <l-option v-for="i in timeseries" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
          </l-select>       
        </div>
        <div class="w-full mr-4">        
          <b>Operator</b><br>
          <l-select v-model="addObj.operator" class="text-xs" :data="operators" placeholder="Please select" :multiple="false" >
              <l-option v-for="i in operators" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
            </l-select>       
        </div>
        <div class="w-full mr-4">        
          <b>Secondary</b><br>
          <l-select v-model="addObj.secondary" class="text-xs" :data="timeseries" placeholder="Please select" :multiple="false" >
              <l-option v-for="i in timeseries" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
            </l-select>       
        </div>
        <div class="w-full">        
          <b>Result</b><br>
          <l-select v-model="addObj.result" class="text-xs" :data="timeseries" placeholder="Please select" :multiple="false" >
              <l-option v-for="i in timeseries" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
            </l-select>       
        </div>
      </div>
      
      <div class="flex w-full justify-between">
        <div>
          <l-button type="success" :disabled="!addObj.primary || !addObj.operator || !addObj.secondary || !addObj.result" @click="onSave">Add calculated timeserie</l-button>&nbsp;
        </div>
        <l-button type="danger" @click="close">Cancel</l-button>
      </div>
    </div>
  </l-modal>
</template>

<script>
import LModal from "@/components/LModal";
import { LInput, LButton, LSelect, LOption } from "@/components/forms";
import Notify from "@/helpers/notify";
import LInfoBox from "@/components/LInfoBox"


export default {
  name: "LLAdd",
  props: [
    "showing",
    "stations"
  ],
  components: {
    LModal,
    LInput,
    LButton,
    LSelect,
    LOption,
    LInfoBox
  },
  data() {
    return {
      addObj:{},
      staSelection: null,
      operators: [ { label:'-', value: '-' }, { label:'+', value: '+' } ],
    }
  },
  computed: {    
    timeseries() {
      const sel = this.stations.find(t => {
        return t.value == this.staSelection;
      });
      this.addObj = {};
      if (!sel) return [];
      
      return sel.timeseries;
    }
  },
  methods: {
    close() {
      this.staSelection = null;
      this.addObj = {}; 
      this.$emit("close");
    },
    onSave() {
      this.$emit("save", this.addObj);
      this.close();
    },
  }
};
</script>